const PaymentTypesEnum = Object.assign({
  BB: 'bb',
  HASPA: 'haspa',
  SECUPAY: 'secupay',
  MANGOPAY: 'mangopay',
});

Object.freeze(PaymentTypesEnum);

export default PaymentTypesEnum;



// WEBPACK FOOTER //
// ./src/enum/financialProducts/PaymentTypes.js